<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only">
    <in-calendar :date.sync="model" :placeholder_label="label"/>  
  </pre_input>
</template>

<script>
import pre_input_js from '@/components/mixins/pre_input';
import filter_rq from './filter_rq';
export default {
  props:{
    multiple:{default:false},
    items:{default:() => []},
    filter_name:{default:''},
    pre_f:{default:''},
    reset_on_value_change:{default:false},//uso normal usa los datos previos, pero para modals de editar y/o crear, se necesitan limpios o con la info de es reg y no la anterior
  },
  mixins: [ filter_rq, pre_input_js ],
  data(){
    return {
      model: null,
      filter_rq_type:['>'],
    }
  },
  computed: {
    k_f() { return this.filter_name || `d__${this.item_key}__${this.pre_f}` },
  },
  watch: {
    'value'(v,v_old) { if (!(v === null && v_old === null) && v != v_old) this.set_model() },
    'model'(v,v_old) { if (!(v === null && v_old === null) && v != v_old) this.upd() },
  },
  methods: {
    set_model(only_cache) {
      const ex_f = {};
      ex_f[this.k_f] = this.value;
      if (!only_cache) this.resetRqStatus();
      //if (only_cache) this.myRequestStatus.rq ? this.myRequestStatus.rq.then(r => this.then_get_rows(r)): Promise.resolve([]);
      /* else  */
      this.pre_get(ex_f,this.k_f);
      this.getRows(ex_f).then(r => (this.model = this.value) && r)
    },
    upd() { this.$emit('update:value', this.model) },
    /* los elementos retornados no afectan las opciones de este filtro */
    then_get_rows(r) { return r },
  },
};
</script>
